import React from 'react';
import backgroundImage from '../../assets/images/homebackground.png';

const Home = () => {
  return (
    <section id="home" className="home" style={{ backgroundImage: `url(${backgroundImage})` }}>
      <div className="hero-overlay"></div>
      <div className="hero-content">
        <h1 className="hero-title">Capture Your Perfect Moments</h1>
        <p className="hero-subtitle">Professional Photography for Weddings, Events & Special Occasions</p>
        <div className="hero-buttons">
          <a href="#contact" className="btn btn-secondary">Book Now</a>
        </div>
      </div>
    </section>
  );
};

export default Home;
